
import Vue from 'vue';
import Component from 'vue-class-component';
import FeedbackEntranceComponent from '../feedback/component/FeedbackEntranceCompnent.vue';
import { Getter, Action } from 'vuex-class';
import { zoomElement } from '../../nmb/util';
import config from '@/params/config';
@Component({
  components: { FeedbackEntranceComponent }
})
export default class UserRelated extends Vue {
  userIcon: string = '';
  userName: string = '';
  shortName: string = '';
  processurl=config.processurl;
  // pending: number = 0; // 待处理
  // feedback: number = 0; // 我的反馈
  // related: number = 0; // 与我相关
  dialogVisible: boolean = false;
  dialogList: Array<{ [key: string]: any }> = [
    {
      icon: 'iconchanpinzixun',
      name: '产品咨询',
      text: '若您有任何对产品的疑问，请选择产品咨询～',
      to: '/feedback/entrance/consultation'
    },
    {
      icon: 'iconchanpinjianyi',
      name: '产品建议',
      text:
        '如果您有任何对产品功能的优化建议/对产品场景的补充，请选择产品建议～',
      to: '/feedback/entrance/proposal'
    },
    {
      icon: 'iconchanpinbug',
      name: '产品BUG',
      text: '如果您在标准演示环境中验证出问题，请选择产品BUG～',
      to: '/feedback/entrance/defect'
    }
  ];

  @Getter feedbackTotal: any;

  @Action('getFeedbackTotal') getFeedbackTotal: Function;

  created() {
    const user = localStorage.logonUser;
    if (!user) return false;
    const arr = JSON.parse(user).UserName.split('');
    if (arr.length > 3) {
      if (arr.indexOf('（') === -1) {
        this.userName = JSON.parse(user).UserName.split('(')[0];
      } else {
        this.userName = JSON.parse(user).UserName.split('（')[0];
      }
    } else {
      this.userName = JSON.parse(user).UserName;
    }
    this.shortName = arr[0];
    this.userIcon = JSON.parse(user).UserIcon;
    this.getFeedbackTotal();
  }

  zoom() {
    return zoomElement();
  }

  toFeedback() {
    this.dialogVisible = !this.dialogVisible;
  }

  // 跳转到反馈中心
  handleClickTOFeedback() {
    debugger;
    window.open(config.processurl);
  }

  // 添加反馈信息
  handlerClickToAddFeedback(item: any) {
    this.$router.push({ path: item.to });
  }
}
